const actions = {

    CP_READ_APPS_REQUEST: 'CP_READ_APPS_REQUEST',
    CP_READ_APPS_SUCCESS: 'CP_READ_APPS_SUCCESS',
    CP_READ_APPS_ERROR: 'CP_READ_APPS_ERROR',

    CP_ACTIVATE_APP_REQUEST: 'CP_ACTIVATE_APP_REQUEST',
    CP_ACTIVATE_APP_SUCCESS: 'CP_ACTIVATE_APP_SUCCESS',
    CP_ACTIVATE_APP_ERROR: 'CP_ACTIVATE_APP_ERROR',

    CP_UPDATE_APPS_REQUEST: 'CP_UPDATE_APPS_REQUEST',
    CP_UPDATE_APPS_SUCCESS: 'CP_UPDATE_APPS_SUCCESS',
    CP_UPDATE_APPS_ERROR: 'CP_UPDATE_APPS_ERROR',

    readAllApps: () => ({
        type: actions.CP_READ_APPS_REQUEST,
    }),

    activateApp: name => ({
        type: actions.CP_ACTIVATE_APP_REQUEST,
        name,
    }),

    updateApps: () => ({
        type: actions.CP_UPDATE_APPS_REQUEST,
    }),
};

export default actions;
